import { render, staticRenderFns } from "./ReviewAdd.vue?vue&type=template&id=13bceb75&scoped=true&"
import script from "./ReviewAdd.vue?vue&type=script&lang=js&"
export * from "./ReviewAdd.vue?vue&type=script&lang=js&"
import style0 from "./ReviewAdd.vue?vue&type=style&index=0&id=13bceb75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bceb75",
  null
  
)

export default component.exports